import {URL_BASE_API } from '../../configs/urlConfigs';
import {LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP} from '../../configs/staticConfigs';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';

import service from '../api';

let userGroup = ''; 

export const otherExpList = (request) => {
    let userGroupData = userGroupUrlCheck(window.location);
    if(userGroupData!==undefined){
        userGroup = userGroupData.user_group; 
    }
    let ENDPOINT = '';
    if(request.data!==undefined){      
      let column = request.data.column;  
      let shiftId = request.data.shiftId ? request.data.shiftId : 0; 
      let affiliateId = request.data.affiliateId; 
      if(userGroup===LOGIN_AFFILIATE_GROUP){
        ENDPOINT = URL_BASE_API+'affiliate/otherexpenses/?column='+column;
      }else if(userGroup===LOGIN_CLIENT_GROUP){
        ENDPOINT = URL_BASE_API+'affiliate/otherexpenses/?column='+column+'&affiliate='+affiliateId;
      }else{
        if(column){
          ENDPOINT = URL_BASE_API+'super-admin/otherexpenses/?column='+column;
        }
      }  
      if(shiftId) ENDPOINT += '&shift_id='+shiftId; 
      
    }else{
      if(userGroup===LOGIN_AFFILIATE_GROUP){
        ENDPOINT = URL_BASE_API+'affiliate/otherexpenses/';
      }else if(userGroup===LOGIN_CLIENT_GROUP){
          ENDPOINT = URL_BASE_API+'affiliate/otherexpenses/';
      }else{
        ENDPOINT = URL_BASE_API+'super-admin/otherexpenses/';
      }
    }   

    return service.get(ENDPOINT);
    
};


export const otherExpAdd = (request) => {
  let userGroupData = userGroupUrlCheck(window.location);
  if(userGroupData!==undefined){
      userGroup = userGroupData.user_group; 
  }
  let ENDPOINT = '';
  if(userGroup===LOGIN_AFFILIATE_GROUP){
    ENDPOINT = URL_BASE_API+'affiliate/otherexpenses/';
  }else{
    ENDPOINT = URL_BASE_API+'super-admin/otherexpenses/';
  }

  return service.post(ENDPOINT,request.data);
  
};

export const otherExpEdit = (request) => {
  let userGroupData = userGroupUrlCheck(window.location);
  if(userGroupData!==undefined){
      userGroup = userGroupData.user_group; 
  }
  let ENDPOINT = '';
  let otherExpId = request.data;
  if(userGroup===LOGIN_AFFILIATE_GROUP){
    ENDPOINT = URL_BASE_API+'affiliate/otherexpenses/'+otherExpId;
  }else{
    ENDPOINT = URL_BASE_API+'super-admin/otherexpenses/'+otherExpId;
  }


  return service.get(ENDPOINT);  
  
};


export const otherExpUpdate = (request) => {
  let userGroupData = userGroupUrlCheck(window.location);
  if(userGroupData!==undefined){
      userGroup = userGroupData.user_group; 
  }
  let ENDPOINT = '';

  let otherExpId = request.data.id;
  if(userGroup===LOGIN_AFFILIATE_GROUP){
    ENDPOINT = URL_BASE_API+'affiliate/otherexpenses/'+otherExpId;
  }else{
    ENDPOINT = URL_BASE_API+'super-admin/otherexpenses/'+otherExpId;
  }
  return service.put(ENDPOINT,request.data);  
  
};

export const otherExpDelete = (request) => {
  let userGroupData = userGroupUrlCheck(window.location);
  if(userGroupData!==undefined){
      userGroup = userGroupData.user_group; 
  }
  let ENDPOINT = '';
  if(userGroup===LOGIN_AFFILIATE_GROUP){
    ENDPOINT = URL_BASE_API+'affiliate/otherexpenses/'+request.data;
  }else{
    ENDPOINT = URL_BASE_API+'super-admin/otherexpenses/'+request.data;
  }
  return service.delete(ENDPOINT);   
};  